import { render, staticRenderFns } from "./MakeOrder.vue?vue&type=template&id=b20f3e84&scoped=true&"
import script from "./MakeOrder.vue?vue&type=script&lang=js&"
export * from "./MakeOrder.vue?vue&type=script&lang=js&"
import style0 from "./MakeOrder.vue?vue&type=style&index=0&id=b20f3e84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20f3e84",
  null
  
)

export default component.exports